import {FC} from 'react';
import {useT} from '@kcast-fe/core';
import {Box, Flex} from '@chakra-ui/react';
import {Svg} from 'ui-kit';

export const NoAccounts: FC = () => {
  const {t} = useT();

  return (
    <Flex gap={'6px'} alignItems={'center'} flexDirection={'column'}>
      <Flex pb={'4px'}>
        <Svg name={'Empty'} />
      </Flex>
      <Box fontWeight={600}>{t('labels.noConnections')}</Box>
      <Box>{t('messages.noConnections')}</Box>
    </Flex>
  );
};
